var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tabs__selectors"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,class:['tabs__heading', {'tabs__heading--active' : index === _vm.selectedIndex}],on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }